<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<c-form-item type="select" label="商品分类" name="product_type_id" options="PRODUCT_CLASSIFY"></c-form-item>
					<c-form-item type="input" label="货号" name="product_itemnumber"></c-form-item>
					<c-form-item type="input" label="商品名称" name="product_name"></c-form-item>
          <c-form-item type="checkbox" label="状态" name="state" :options="productState"></c-form-item>
        </c-form>
			</m-search>
			
            <div ref="list" class="product-list flex-grow">
                <ul>
                    <li v-for="(item, i) in productList" :key="item.product_id" :class="{'z-active': item.init_sort_value != item.current_sort_value}">
                        <p class="sort">{{item.current_rank}}</p>
                        <c-image :src="item.product_img_url" width="170" height="113"></c-image>
                        <p class="name ellipsis">{{item.product_name}}</p>
                        <p class="score flex-between">
	                        <span>当前权重:<strong style="color:red">{{item.current_sort_value}}</strong></span>
	                        <span>初始权重:<strong style="color:gray">{{item.init_sort_value}}</strong></span>
                        </p>
                        <div class="flex-between-center">
                            <div class="flex">
                                <c-input v-model="item.edit_value" class="input" type="number" width="48" height="24" :limit="[0,999999]"></c-input>
                                <button @click="submit(item)">加权</button>
                                <button @click="submit(item, true)">还原</button>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            
            <pagination ref="pagination" :total="total" @handle="update"></pagination>
		</module>
	</page>
</template>

<script>
    import pagination from '@/components/public/pagination.vue'
    
	export default {
		name: 'm_product_sort',
        
        components: {
            pagination
        },
		
		data() {
			return {
                productList: [],
                total: 0,
                productState: [{
                  name: '上架',
                  value: 2
                }, {
                  name: '下架',
                  value: 1
                }],
			}
		},
		
		mounted() {
			this.$refs.search.search();
		},
		
		methods: {
			searchHandle(data) {
                this._searchParam = data;
                this.$refs.pagination.update(1);
			},
            
            update(data) {
                let load = this.$loading({
                    dom: this.$refs.list
                });
				this.request({
					url: '/product_sort/list',
					data: Object.assign(data, this._searchParam || {}),
                    success: data => {
                        this.productList = data;
                    },
                    response: res => {
                        load.close();
                        this.total = res.total;
                    }
				});
            },
            
            submit(item, reset) {
				if(!reset && !item.edit_value){//设置权重
					this.$message({
						text: '请输入加权数值',
						icon: 'error'
					});
					return;
				}
				this.request({
					url: '/product_sort/set_weight',
					data: {
                        product_id: item.product_id,
                        weight_value: reset ? parseInt(item.init_sort_value - item.current_sort_value) : item.edit_value
                    },
                    success: data => {
                        this.$refs.pagination.update();
                    }
				});
            }
		}
	}
</script>

<style lang="stylus" scoped>
    .product-list {
        overflow: auto;
        
        ul {
            overflow: hidden;
            
            li {
                box-sizing: border-box
                float: left;
                position: relative;
                width: 180px;
                border: 1px solid #ddd;
                padding: 6px;
                margin-left: 20px;
                margin-bottom: 20px;
                
                &.z-active {
                    border-color: #C6E4FF;
                    background: #F5FdFF;
                }
                
                .sort {
                    z-index: 1;
                    position: absolute;
                    right: 0;
                    top: 0;
                    min-width: 16px;
                    padding: 0 4px;
                    line-height: 18px;
                    font-size: 12px;
                    text-align: center;
                    color: #fff;
                    background: rgba(0,0,0,.6);
                }
                
                .name {
                    margin: 10px 0;
                    font-size: 13px;
                }
                
                .score {
                    margin-bottom: 10px;
                    font-size: 12px;
                    color: #666;
                }
                
                .input {
                    padding: 0 4px;
                    font-size: 12px;
                }
                
                button {
                    width: 36px;
                    height: 24px;
                    border: 1px solid #BDD2E3;
                    margin-left: -1px;
                    font-size: 12px;
                    color: #4A9DDF;
                    background: #F3FAFF;
                        
                    &:hover {
                        border-color: #B4CFE4;
                        color: #3E8ECE;
                        background: #fff;
                    }
                    
                    &:nth-last-child(1) {
                        margin-left: 6px;
                        border-color: #999;
                        color: #333;
                        background: #fff;
                        
                        &:hover {
                            border-color: #333;
                            color: #000;
                        }
                    }
                }
            }
        }
    }
</style>